/* eslint-disable */
import VueStoreService from './VueStoreService';

const StockExcelService = {
  async listItems(url, store) {
    const resp = await VueStoreService.get('stock-excel/items' + (url || ''), store);
    return resp;
  },

  async listBatches(store) {
    const resp = await VueStoreService.get('stock-excel/batches', store);
    return resp;
  },

  async uploadExcel(file, store) {
    const form = new FormData();
    form.append('file', file);
    const resp = await VueStoreService.postFile('stock-excel/upload', form, store);
    return resp;
  },

  async softDeleteBatch(id, store) {
    return await VueStoreService.delete(`stock-excel/batches/${id}`, store);
  },
};

export default StockExcelService;